export const TYPE_META = {
    HOME: 'HOME',
    CONTATOS: 'CONTATOS',
    PERGUNTAS_FREQUENTES: 'PERGUNTAS_FREQUENTES',
    COMO_FUNCIONA: 'COMO_FUNCIONA',
    INDIQUE_GANHE: 'INDIQUE_GANHE',
    VANTAGENS: 'VANTAGENS',
    HOTEIS: 'HOTEIS',
    BUSCA_HOTEIS: 'BUSCA_HOTEIS',
    DESTINOS: 'DESTINOS',
    CARRINHO: {
        FACA_PARTE: 'FACA_PARTE',
        DADOS_PESSOAIS: 'DADOS_PESSOAIS',
        CONFIRMACAO_SALES: 'CONFIRMACAO_SALES',
        DEFAULT: 'CARRINHO_DEFAULT',
    },
    POLITICA_PRIVACIDADE: 'POLITICA_PRIVACIDADE',
    A_MONTREAL: 'A_MONTREAL',
};
export const TITLE_DEFAULT = 'Montreal Viagens - Diárias em hotéis com economia';
export const META_DEFAULT = {
    name: 'description',
    // tslint:disable-next-line:max-line-length
    content: 'A Montreal Viagens é a forma mais econômica de adquirir diárias nos melhores hotéis do Brasil e no exterior. Aqui você tem até 24 meses (mediante renovação) para escolher um dos hotéis disponíveis e marcar sua viagem. E tem mais: na hora de marcar sua reserva você não precisará se preocupar com taxas extras como complemento e o regime de alimentação. Já tá tudo incluso no seu plano! Tudo isso em uma assinatura anual com pagamento em 12x sem juros e sem comprometer o limite do seu cartão de crédito.'
};
export const TITLE = [
    {
        type: TYPE_META.HOME,
        value: 'Montreal Viagens - Até 60% de economia em sua hospedagem'
    },
    {
        type: TYPE_META.CONTATOS,
        value: 'Fale conosco | Como entrar em contato - Montreal Viagens'
    },
    {
        type: TYPE_META.PERGUNTAS_FREQUENTES,
        value: 'Tire suas dúvidas | Perguntas frequentes - Montreal Viagens'
    },
    {
        type: TYPE_META.COMO_FUNCIONA,
        value: 'Como funciona o clube de hospedagem da Montreal Viagens'
    },
    {
        type: TYPE_META.INDIQUE_GANHE,
        value: 'Indique e Ganhe | Viaje com descontos - Montreal Viagens'
    },
    {
        type: TYPE_META.VANTAGENS,
        value: 'Vantagens Montreal + | Clube de Vantagens - Montreal Viagens'
    },
    {
        type: TYPE_META.HOTEIS,
        value: 'Home | Encontre os melhores hotéis na Montreal Viagens'
    },
    {
        type: TYPE_META.BUSCA_HOTEIS,
        value: 'Encontre os melhores hotéis com o clube - Montreal Viagens'
    },
    {
        type: TYPE_META.DESTINOS,
        value: 'Destinos para sua próxima viagem | Buscar - Montreal Viagens'
    },
    {
        type: TYPE_META.CARRINHO.DEFAULT,
        value: 'Cadastre-se no Clube | Monte o seu plano - Montreal Viagens'
    },
    {
        type: TYPE_META.CARRINHO.FACA_PARTE,
        value: 'Montreal Viagens - Faça Parte'
    },
    {
        type: TYPE_META.CARRINHO.DADOS_PESSOAIS,
        value: 'Montreal Viagens - Dados Pessoais'
    },
    {
        type: TYPE_META.CARRINHO.CONFIRMACAO_SALES,
        value: 'Montreal Viagens - Confirmação Sales'
    },
    {
        type: TYPE_META.POLITICA_PRIVACIDADE,
        value: 'Saiba sobre a Política de Privacidade - Montreal Viagens'
    },
    {
        type: TYPE_META.A_MONTREAL,
        value: 'Quem somos | Conheça nossa história - Montreal Viagens'
    },
];
export const META = [
    {
        type: TYPE_META.HOME,
        // tslint:disable-next-line:max-line-length
        content: 'Monte seu Plano Agora e Economize até 60%! Tudo do seu jeito, para você e sua família aproveitarem as próximas viagens sem se preocupar.'
    },
    {
        type: TYPE_META.CONTATOS,
        // tslint:disable-next-line:max-line-length
        content: 'Fale conosco pelo chat aqui no site, pelo WhatsApp, telefone ou em nossas redes sociais! Nossa atendente virtual, está disponível todos os dias da semana.'
    },
    {
        type: TYPE_META.PERGUNTAS_FREQUENTES,
        // tslint:disable-next-line:max-line-length
        content: 'Tire suas dúvidas atráves das perguntas frequentes sobre o Clube, como utilizar, reservar hotéis e melhor aproveitar suas diárias.'
    },
    {
        type: TYPE_META.COMO_FUNCIONA,
        // tslint:disable-next-line:max-line-length
        content: 'Tudo o que você precisa saber sobre Clube de Hospedagem, Clube de Turismo ou Clube de Viagem. Entenda o que é um Clube de Hospedagem e descubra mais'
    },
    {
        type: TYPE_META.INDIQUE_GANHE,
        // tslint:disable-next-line:max-line-length
        content: 'Viajar com desconto já é sensacional, não é mesmo? E se a gente te falar que, além de economizar, tem como você ganhar dinheiro direto na sua conta?'
    },
    {
        type: TYPE_META.VANTAGENS,
        // tslint:disable-next-line:max-line-length
        content: 'Um clube de vantagens para todos os nossos Clientes! Confira descontos e vantagens aos quais você terá acesso.'
    },
    {
        type: TYPE_META.HOTEIS,
        // tslint:disable-next-line:max-line-length
        content: 'Nosso conceito é simples: você paga pequenas parcelas por mês e adquire diárias para se hospedar em milhares de hotéis no Brasil e no exterior.'
    },
    {
        type: TYPE_META.BUSCA_HOTEIS,
        // tslint:disable-next-line:max-line-length
        content: 'Verifique e encontre os melhores hotéis com o clube, filtrando por praia, luxo, relaxar e natureza. Busque por hotéis e apartamentos, bares e restaurantes.'
    },
    {
        type: TYPE_META.DESTINOS,
        // tslint:disable-next-line:max-line-length
        content: 'Você determina quantas parcelas cabem no seu orçamento e adquire diárias gastando menos do que reservando por sites ou diretamente com o hotel.'
    },
    {
        type: TYPE_META.CARRINHO.DEFAULT,
        // tslint:disable-next-line:max-line-length
        content: 'Para uma viagem sem preocupação, com benefícios incríveis e um toque de luxo. O plano oferece hotéis exclusivos com apartamentos da categoria superior.'
    },
    {
        type: TYPE_META.CARRINHO.FACA_PARTE,
        // tslint:disable-next-line:max-line-length
        content: 'Para uma viagem sem preocupação, com benefícios incríveis e um toque de luxo. O plano oferece hotéis exclusivos com apartamentos da categoria superior.'
    },
    {
        type: TYPE_META.CARRINHO.DADOS_PESSOAIS,
        // tslint:disable-next-line:max-line-length
        content: 'Para uma viagem sem preocupação, com benefícios incríveis e um toque de luxo. O plano oferece hotéis exclusivos com apartamentos da categoria superior.'
    },
    {
        type: TYPE_META.CARRINHO.CONFIRMACAO_SALES,
        // tslint:disable-next-line:max-line-length
        content: 'Para uma viagem sem preocupação, com benefícios incríveis e um toque de luxo. O plano oferece hotéis exclusivos com apartamentos da categoria superior.'
    },
    {
        type: TYPE_META.POLITICA_PRIVACIDADE,
        // tslint:disable-next-line:max-line-length
        content: 'A Política de Privacidade descreve como os dados pessoais de titulares são tratados, em acordo com a legislação vigente Lei Geral de Proteção de Dados.'
    },
    {
        type: TYPE_META.A_MONTREAL,
        // tslint:disable-next-line:max-line-length
        content: 'Os benefícios de um clube de hospedagem e os serviços de uma agência de viagem, facilitando e simplificando suas viagens no Brasil e no exterior.'
    },
];

